import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { DEFAULT_GRID_PAGE_SIZE } from "../const";

const DEFAULT_PAGE = 1;

interface GridParams {
  pageAlerts: number;
  pagesizeAlerts: number;
  pageMethods: number;
  pagesizeMethods: number;
}

type ParamKeys = keyof GridParams;

const PARAM_DEFAULTS: Record<ParamKeys, number> = {
  pageAlerts: DEFAULT_PAGE,
  pagesizeAlerts: DEFAULT_GRID_PAGE_SIZE,
  pageMethods: DEFAULT_PAGE,
  pagesizeMethods: DEFAULT_GRID_PAGE_SIZE
};

const useAlertsConfigurationGridNavigation = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const isAnyParamMissing = Object.keys(PARAM_DEFAULTS).some(
      key => !searchParams.has(key)
    );

    if (isAnyParamMissing) {
      const defaultParams: Record<string, string> = {};
      Object.entries(PARAM_DEFAULTS).forEach(([key, value]) => {
        if (!searchParams.has(key)) {
          defaultParams[key] = String(value);
        }
      });
      setSearchParams(defaultParams);
    }
  }, []);

  const getParams = (): GridParams => ({
    pageAlerts: parseInt(
      searchParams.get("pageAlerts") || String(DEFAULT_PAGE),
      10
    ),
    pagesizeAlerts: parseInt(
      searchParams.get("pagesizeAlerts") || String(DEFAULT_GRID_PAGE_SIZE),
      10
    ),
    pageMethods: parseInt(
      searchParams.get("pageMethods") || String(DEFAULT_PAGE),
      10
    ),
    pagesizeMethods: parseInt(
      searchParams.get("pagesizeMethods") || String(DEFAULT_GRID_PAGE_SIZE),
      10
    )
  });

  const updateParams = (newParams: Partial<GridParams>) => {
    const updatedParams: Record<string, string> = {};
    const currentParams = getParams();

    Object.entries({ ...currentParams, ...newParams }).forEach(
      ([key, value]) => {
        updatedParams[key] = String(value);
      }
    );

    setSearchParams(updatedParams);
  };

  return {
    pageParams: getParams(),
    updateParams
  };
};

export default useAlertsConfigurationGridNavigation;
